import { TABLE_COLUMN_TYPE } from "../../../../constants"
import { SummaryStatements, TableColumn } from "../../../../types"
import { KSpan } from "kahuna-base-react-components"
import { lang } from "../../../../constants/languages"
import { getCurrency } from "../../../../utility"
import { DocumentArrowDownIcon } from "@heroicons/react/24/solid"

const getStatementsColumns = (
  isAdmin: boolean,
  onReceiptClick?: (transactionId: string) => void,
  onInvoiceClick?: (id: number, isAdvance: boolean) => void
): TableColumn[] => {
  const columns: TableColumn[] = [
    {
      header: lang.royalties.statements.columns.paidAmount,
      headerStyle: {
        textAlign: "left",
        minWidth: "120px",
        width: "15%"
      },
      overrideHeader: () => (
        <KSpan text={lang.royalties.statements.columns.paidAmount} color="#111" fontWeight={500} fontSize={14} />
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        const paidAmount = row.paidAmount.toLocaleString("en-EN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        const currency = getCurrency(row.currency)
        return (
          <div>
            <KSpan text={`${currency}${paidAmount}`} />
          </div>
        )
      }
    },
    {
      header: lang.royalties.statements.columns.reportingPeriod,
      headerStyle: {
        textAlign: "left",
        minWidth: "120px",
        width: "15%"
      },
      overrideHeader: () => (
        <KSpan text={lang.royalties.statements.columns.reportingPeriod} color="#111" fontWeight={500} fontSize={14} />
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        return (
          <div className="flex gap-1">
            <KSpan text={row.date} />
          </div>
        )
      }
    },
    {
      header: lang.royalties.statements.columns.paymentDay,
      headerStyle: {
        textAlign: "left",
        minWidth: "120px",
        width: "15%"
      },
      overrideHeader: () => (
        <KSpan text={lang.royalties.statements.columns.paymentDay} color="#111" fontWeight={500} fontSize={14} />
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        return (
          <div>
            <KSpan
              text={`${row.paymentDay.substring(6, 8)}.${row.paymentDay.substring(4, 6)}.${row.paymentDay.substring(
                0,
                4
              )}`}
            />
          </div>
        )
      }
    },
    {
      header: lang.royalties.statements.columns.paymentType,
      headerStyle: {
        textAlign: "left",
        minWidth: "120px",
        width: "15%"
      },
      overrideHeader: () => (
        <KSpan text={lang.royalties.statements.columns.paymentType} color="#111" fontWeight={500} fontSize={14} />
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        return (
          <div>
            <KSpan text={lang.royalties.statements[row.paymentType]} />
          </div>
        )
      }
    },
    {
      header: lang.royalties.statements.columns.description,
      headerStyle: {
        textAlign: "left",
        minWidth: "120px",
        width: "20%"
      },
      overrideHeader: () => (
        <KSpan text={lang.royalties.statements.columns.description} color="#111" fontWeight={500} fontSize={14} />
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        return (
          <div>
            <KSpan text={row.description ? lang.royalties.statements.description_codes[row.description] : "-"} />
          </div>
        )
      }
    }
  ]

  if (isAdmin) {
    columns.push({
      header: lang.royalties.statements.columns.invoice,
      headerStyle: {
        alignItems: "center",
        width: "10%"
      },
      overrideHeader: () => (
        <div className="flex justify-center" style={{ width: "100%" }}>
          <KSpan text={lang.royalties.statements.columns.invoice} color="#111" fontWeight={500} fontSize={14} />
        </div>
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        return (
          <div
            className="flex justify-center cursor-pointer"
            onClick={(e) => {
              e.stopPropagation()
              onInvoiceClick?.(row.id, row.isAdvance)
            }}
            title="Download Invoice"
          >
            <DocumentArrowDownIcon className="w-5 h-5 text-black" />
          </div>
        )
      }
    })
    columns.push({
      header: lang.royalties.statements.columns.receipt,
      headerStyle: {
        alignItems: "center",
        width: "10%"
      },
      overrideHeader: () => (
        <div className="flex justify-center" style={{ width: "100%" }}>
          <KSpan text={lang.royalties.statements.columns.receipt} color="#111" fontWeight={500} fontSize={14} />
        </div>
      ),
      type: TABLE_COLUMN_TYPE.FUNCTION,
      render: (row: SummaryStatements) => {
        const receiptId = row.transactionId || row.paymentBatchBatchId
        if (!receiptId) {
          return (
            <div className="flex justify-center">
              <KSpan text="-" />
            </div>
          )
        }
        return (
          <div
            className="flex justify-center cursor-pointer"
            onClick={(e) => {
              e.stopPropagation()
              onReceiptClick?.(receiptId!)
            }}
            title="Download Receipt"
          >
            <DocumentArrowDownIcon className="w-5 h-5 text-black" />
          </div>
        )
      }
    })
  }
  return columns
}

export default getStatementsColumns
